export default {
  DATE_TIME: 'dd/MM/yyyy HH:mm:ss',
  DATE_TIME_EXPORT: 'DD/MM/YYYY HH:mm:ss',
  DATE: 'dd/MM/yyyy',
  TIME: 'HH:mm:ss',
  MOMENT: 'DD/MM/YYYY',
  LOCALES: 'en-GB',
  DELIVERY_DATE: 'YYYY-MM-DD',
};
